import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import {
  eliminarSocio,
  guardarSocio,
  obtenerSocio,
  obtenerSocios,
  setDatosSocio,
  setListadoSocios,
  setMessageError,
  setMessageSuccess,
} from "../../sliceRedux/ValidarReserva.slice";
import { useSelector } from "react-redux";
import RegistrarSocios from "./RegistrarSocios";
import RenderToast from "../../componentes/RenderToast";
import { confirmDialog } from "primereact/confirmdialog";
import Observation from "../../componentes/Observation";
import { nemonicoEstadoDeshabilitar, nemonicoSistema } from "../../constantes/appConstantes";

const Socios = (props) => {
  const {
    showLoader,
    hideLoader,
    dispatch,
    stepperRef,
    toast,
    codSolConstitucion,
    reserva,
    fecReunionAsamblea,
    codGrupoConstAdec,
    numSocios,
    nemEstado,
    nemTipoSolicitud,
  } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [bandejaSocios, setBandejaSocios] = useState([]);
  const [modal, setModal] = useState(false);
  const [socio, setSocio] = useState({});
  const listadoSocios = useSelector((state) => state.validar.listadoSocios);
  const datosSocio = useSelector((state) => state.validar.datosSocio);
  const messageSuccess = useSelector((state) => state.validar.messageSuccess);
  const messageError = useSelector((state) => state.validar.messageError);
  const [deshabilitarCampos, setDeshabilitarCampos] = useState(false);

  useEffect(() => {
    showLoader();
    dispatch(obtenerSocios(codSolConstitucion));
  }, []);

  useEffect(() => {
    if (listadoSocios.code === 200) {
      let listado = listadoSocios?.object?.listSocios ?? [];
      setBandejaSocios(listado);
      let estado =
        nemonicoEstadoDeshabilitar.includes(nemEstado) && !listadoSocios?.object?.observacion;
      setDeshabilitarCampos(estado);
      if (listado.length === 0) {
        let datSocio = {
          numTelefono: reserva?.numTelefonoPersona ?? "",
          numCelular: reserva?.numCelularPersona ?? "",
          txtEmail: reserva?.txtEmailPersona ?? "",
          codCatTipoIdentificacion: reserva?.codCatTipoIdentificacion ?? "",
          numIdentificacion: reserva?.numIdentificacion ?? "",
          nombres: reserva?.nombreSolicitante ?? "",
          nemCargo: nemonicoSistema.CARGO_REPRESENTANTE_LEGAL,
          codParamCargoGrupoSoc: codGrupoConstAdec,
        };
        setSocio(datSocio);
        toggleModal();
      }
    }

    return () => {
      hideLoader();
      dispatch(setListadoSocios({ ...listadoSocios, ...{ code: 0 } }));
    };
  }, [listadoSocios.code]);

  useEffect(() => {
    if (datosSocio.code === 200) {
      setSocio(datosSocio?.object ?? {});
      toggleModal();
    }

    return () => {
      hideLoader();
      dispatch(setDatosSocio({ ...datosSocio, ...{ code: 0 } }));
    };
  }, [datosSocio.code]);

  const renderHeader = (
    <div className="flex justify-content-between">
      <Button
        icon="pi pi-user"
        className="mr-2"
        label="Registrar socio"
        disabled={deshabilitarCampos}
        onClick={() => {
          if (socio.nemCargo !== nemonicoSistema.CARGO_REPRESENTANTE_LEGAL) {
            setSocio({});
          }
          toggleModal();
        }}
      />
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={globalFilter} onChange={(e) => buscar(e)} placeholder="Buscar..." />
        </IconField>
      </div>
    </div>
  );

  const buscar = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    if (value === "") {
      setBandejaSocios([...(listadoSocios?.object?.listSocios ?? [])]);
      return;
    }

    const filtro = listadoSocios?.object?.listSocios?.filter((item) => {
      return (
        item.nomCatTipoIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.numIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.nombres?.toUpperCase().includes(value.toUpperCase()) ||
        item.txtEmail?.toUpperCase().includes(value.toUpperCase()) ||
        item.numCelular?.toUpperCase().includes(value.toUpperCase()) ||
        item.numTelefono?.toUpperCase().includes(value.toUpperCase())
      );
    });

    setBandejaSocios(filtro);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const callbackSaveSocio = (data) => {
    showLoader();
    dispatch(guardarSocio(data));
  };

  useEffect(() => {
    if (messageSuccess != "") {
      RenderToast(toast, "success", "Éxito", messageSuccess);
      modal && toggleModal();
      dispatch(obtenerSocios(codSolConstitucion));
      setSocio({});
    }
    return () => {
      dispatch(setMessageSuccess(""));
    };
  }, [messageSuccess]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
      hideLoader();
    }
    return () => {
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const callbackSaveEliminarSocio = (rowData) => {
    showLoader();
    let data = { codSolConsSocio: rowData.codSolConstSocios };
    dispatch(eliminarSocio(data));
  };

  const actionTemplate = (rowData) => {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          rounded
          className="mr-1"
          tooltip="Editar"
          disabled={rowData.habEditar}
          tooltipOptions={{ position: "top" }}
          onClick={() => {
            showLoader();
            dispatch(obtenerSocio(rowData.codSolConstSocios));
          }}
        />
        <Button
          icon="pi pi-trash"
          rounded
          tooltip="Eliminar"
          severity="danger"
          disabled={rowData.habEliminar}
          tooltipOptions={{ position: "top" }}
          onClick={() => {
            confirmDialog({
              message: "¿Está seguro que desea eliminar?",
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              rejectLabel: "Cancelar",
              acceptLabel: "Aceptar",
              accept: () => callbackSaveEliminarSocio(rowData),
              reject: null,
            });
          }}
        />
      </>
    );
  };

  return (
    <>
      <div className="card">
        <Observation observationValue={listadoSocios?.object?.observacion} />
        <DataTable
          header={renderHeader}
          className="p-datatable-responsive-demo"
          paginator
          rows={10}
          dataKey="codSolConstSocios"
          loading={undefined}
          value={bandejaSocios}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column
            body={rowIndexTemplate}
            header="Nro."
            sortable
            sortField="codSolConstSocios"
            headerStyle={{ textAlign: "center" }}
            style={{ width: "3%" }}
            bodyStyle={{
              textAlign: "center",
            }}
          />
          <Column
            field="nomCatTipoIdentificacion"
            header="Tipo de identificación"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numIdentificacion"
            header="Identificación"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nombres"
            header="Apellidos y nombres"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numCelular"
            header="Celular"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="numTelefono"
            header="Teléfono"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="txtEmail"
            header="Correo electrónico"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            header="Acciones"
            headerStyle={{ textAlign: "center" }}
            bodyStyle={{
              textAlign: "center",
            }}
            body={actionTemplate}
          ></Column>
        </DataTable>
        <div className="flex pt-4 justify-content-end">
          <Button
            label="Anterior"
            severity="secondary"
            icon="pi pi-arrow-left"
            className="mr-2"
            onClick={() => stepperRef.current.prevCallback()}
          />
          <Button
            label="Continuar"
            icon="pi pi-arrow-right"
            iconPos="right"
            severity="warning"
            disabled={bandejaSocios.length < numSocios}
            onClick={() => stepperRef.current.nextCallback()}
          />
        </div>
      </div>
      {modal && (
        <RegistrarSocios
          modal={modal}
          callbackModal={toggleModal}
          showLoader={showLoader}
          hideLoader={hideLoader}
          dispatch={dispatch}
          callbackSaveSocio={callbackSaveSocio}
          codSolConstitucion={codSolConstitucion}
          toast={toast}
          socio={socio}
          fecReunionAsamblea={fecReunionAsamblea}
          nemTipoSolicitud={nemTipoSolicitud}
        />
      )}
    </>
  );
};
export default Socios;
